import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
    fonts: {
        body: "Open Sans, sans-serif",
        heading: `'Open Sans', sans-serif`,
    },
    sizes: {
        container: {
            xl: '1248px',
            lg: '960px',
            md: '778px',
            sm: '580px',
        },
    },
    breakpoints: {
        xl: '1230px',
    },
    colors: {
        text: {
            strong: '#0C0C0D',
            secondary: '#4B4B4E',
            info: '#717175',
            muted: '#B6B6B9',
            white: '#FFFFFF',
            danger: '#B62626',
            link: '#245AF0',
            success: '#00853D',
        },
        icon: {
            secondary: '#58585B',
            strong: '#19191A',
            info: '#77777C',
            danger: '#B62626',
            white: '#FFFFFF',
            active: '#245AF0',
            success: '#00853D'
        },
        bg: {
            1: '#FFFFFF',
            2: '#FAFAFA',
            3: '#EDEEF0',
            4: '#212328',
            5: '#F5F5F5',
            6: '#000000',
            white: '#FFFFFF',
            disabled: '#EAEAEB',
            hover: '#F5F5F5',
            secondary: '#FAFAFA',
            blue: '#F4F7FF',
            'blue.300': '#F8F7FD',
            'bg.hover.light': '#F2F2F2',
        },
        field: {
            white: '#FFFFFF',
            border: '#CBCBCD',
            borderActive: '#245AF0',
            borderError: '#DB3333',
        },
        border: {
            light: '#EAEAEB',
            primary: '#245AF0', 
            defaultDark: '#97979B'
        },
        decorative: {
            iconBlue: '#1D48C0',
            textBlue: '#163690',
            'blue.100': '#E9EFFE',
            'blue.200': '#D3DEFC',
            iconPurple: '#5C43A3',
            'purple.200': '#E3DDF5',
            greenAccent: '#006D33',
            'green.200': '#CCE9D9',
            'yellow.300': '#FFDF99',
            'red.100': '#FCEAEA'
        },
        button: {
            secondary: '#CBCBCD',
            disabled: '#F5F5F5',
            primary: '#245AF0',
            ghost: '#EAEAEB',
            danger: '#DB3333',
            secondaryHover: '#F5F5F5',
            primaryHover: '#1D48C0',
            dangerSecondaryDefault: '#F9D5D5',
            dangerSecondaryHover: '#FCEAEA',
        },
        permanent: {
            bg: '#19191A',
            textLight: '#FAFAFA',
        },
        btn: {
            primaryDefault: '#2F80ED',
            primaryHover: '#529CFF',
        },
    },
    components: {
        Button: {
            baseStyle: {
                lineHeight: '1.25',
                borderRadius: '24px',
                fontSize: 'sm',
                fontWeight: '600',
            },
            sizes: {
                base: {
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    height: '36px',
                },
                xl: {
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                },
            },
            variants: {
                primary: {
                    border: 'none',
                    bg: 'btn.primaryDefault',
                    color: 'text.white',
                    _hover: { bg: 'btn.primaryHover' },
                    fontSize: 'sm',
                },
            },
        },
    },
    zIndexes: {
        hide: -1,
        auto: 'auto',
        base: 0,
        docked: 10,
        dropdown: 1000,
        sticky: 1100,
        banner: 1200,
        overlay: 1300,
        modal: 1400,
        popover: 1500,
        skipLink: 1600,
        toast: 1700,
        tooltip: 1800,
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2rem",
        "4.225xl": "2.225rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem",
      },
})

export default theme